import React from "react";


const TabLabel = (props) => {
    const {name, count } = props;
    if (name != null) {
        if (count > 0) {
            return (
                <span>{name} <span className="tabSummary">{count}</span></span>
            );
        } else {
            return (
                <span>{name}</span>
            );
        }

    } else{
        return null;
    }

};
export default TabLabel;